/** @jsx jsx */
import { jsx } from "theme-ui"

const styles = {
  zIndex: 1,
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  textTransform: "uppercase",
  width: "100vw",
  padding: ["5px 10px", "5px 10px", "5px 10px", "5px 20px"],
  fontSize: ["14px", "14px", "14px", "15px"],
  transform: [
    "translate(-8px, -12px)",
    "translate(-8px, -12px)",
    "translate(-8px, -12px)",
    "translate(-20px, -20px)",
  ],
  backgroundColor: "#F4E7A9",
  color: "#333333",
}
function Announcement({ children }) {
  return <div sx={styles}>{children}</div>
}

export default Announcement
